const DEFAULT_FULLSCREEN = false
const DEFAULT_INFO = false
const DEFAULT_PERSISTENT = true
const DEFAULT_MAX_WIDTH = 350
const DEFAULT_TITLE = 'title'
const DEFAULT_TEXT = ''
const DEFAULT_FIELDS = []
const DEFAULT_CANCEL = 'cancel'
const DEFAULT_SUBMIT = 'submit'
const DEFAULT_MODEL = null
const DEFAULT_SUBMIT_CB = () => {}

function init (state) {
  state.value = false
  state.fullscreen = DEFAULT_FULLSCREEN
  state.persistent = DEFAULT_PERSISTENT
  state.maxWidth = DEFAULT_MAX_WIDTH
  state.title = DEFAULT_TITLE
  state.text = DEFAULT_TEXT
  state.fields = DEFAULT_FIELDS
  state.cancel = DEFAULT_CANCEL
  state.submit = DEFAULT_SUBMIT
  state.model = DEFAULT_MODEL
  state.submitCb = DEFAULT_SUBMIT_CB
}

function setDialog (state, payload) {
  state.value =
    payload.value === null || payload.value === undefined
      ? false
      : payload.value
  state.fullscreen =
    payload.fullscreen === null || payload.fullscreen === undefined
      ? DEFAULT_FULLSCREEN
      : payload.fullscreen
  state.info =
    payload.info === null || payload.info === undefined
      ? DEFAULT_INFO
      : payload.info
  state.persistent =
    payload.persistent === null || payload.persistent === undefined
      ? DEFAULT_PERSISTENT
      : payload.persistent
  state.maxWidth =
    payload.maxWidth === null || payload.maxWidth === undefined
      ? DEFAULT_MAX_WIDTH
      : payload.maxWidth
  state.title =
    payload.title === null || payload.title === undefined
      ? DEFAULT_TITLE
      : payload.title
  state.text =
    payload.text === null || payload.text === undefined
      ? DEFAULT_TEXT
      : payload.text
  state.fields =
    payload.fields === null || payload.fields === undefined
      ? DEFAULT_FIELDS
      : payload.fields
  state.cancel =
    payload.cancel === null || payload.cancel === undefined
      ? DEFAULT_CANCEL
      : payload.cancel
  state.submit =
    payload.submit === null || payload.submit === undefined
      ? DEFAULT_SUBMIT
      : payload.submit
  state.model =
    payload.model === null || payload.model === undefined
      ? DEFAULT_MODEL
      : payload.model
  state.submitCb =
    payload.submitCb === null || payload.submitCb === undefined
      ? DEFAULT_SUBMIT_CB
      : payload.submitCb
}

export const _Dialog = {
  namespaced: true,
  state: {
    value: false,
    fullscreen: DEFAULT_FULLSCREEN,
    info: DEFAULT_INFO,
    persistent: DEFAULT_PERSISTENT,
    maxWidth: DEFAULT_MAX_WIDTH,
    title: DEFAULT_TITLE,
    text: DEFAULT_TEXT,
    fields: DEFAULT_FIELDS,
    cancel: DEFAULT_CANCEL,
    submit: DEFAULT_SUBMIT,
    model: DEFAULT_MODEL,
    submitCb: DEFAULT_SUBMIT_CB
  },
  getters: {
    GET: state => state
  },
  mutations: {
    SET_DIALOG (state, payload) {
      if (payload && payload.action === 'submit') {
        state.submitCb(state.model, state.fields)
      }
      if (payload === null || payload === undefined) {
        init(state)
        return
      }
      setDialog(state, payload)
    },
    HIDE (state) {
      state.value = false
    }
  },
  actions: {
    SET_DIALOG ({ commit }, payload) {
      if (payload && payload.value) {
        commit('SET_DIALOG', payload)
      } else {
        commit('HIDE')
        setTimeout(() => {
          commit('SET_DIALOG', payload)
        }, 300)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dialog.js